import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from "firebase/app";

// Silence debug logging in production builds (warnings and errors still show)
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
}

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAyUbGqBgTulVRCJtLy8AbJp3UC6hMHdMQ",
  authDomain: "createv-b669d.firebaseapp.com",
  projectId: "createv-b669d",
  storageBucket: "createv-b669d.appspot.com",
  messagingSenderId: "999822200666",
  appId: "1:999822200666:web:c2ce10bf062ac8c344ad63"
};

// Initialize Firebase
initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();